import React, { useState, useEffect } from 'react';
import { MapPin, ChevronRight, PlayCircle, BarChart3 } from 'lucide-react';
import GateStatusBanner from './GateStatusBanner';
import VisitorAlerts from './VisitorAlerts';
import CheckInOut from './CheckInOut';
import MyVisits from './MyVisits';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function VisitsTab() {
  const [summary, setSummary] = useState(null);
  const [showFull, setShowFull] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const token = localStorage.getItem('token');
        const r = await fetch(`${API_URL}/api/staff/today-summary`, { headers: { 'Authorization': `Bearer ${token}` } });
        if (r.ok) setSummary(await r.json());
      } catch {}
    })();
  }, [showFull]);

  return (
    <div className="space-y-3" data-testid="visits-tab">
      <GateStatusBanner />
      <VisitorAlerts />
      <CheckInOut />

      <div className="bg-white rounded-xl p-4 shadow-sm" data-testid="visits-summary-card">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <MapPin size={16} className="text-blue-600" />
            <h3 className="font-semibold text-sm">Today's Visits</h3>
          </div>
          {summary?.ongoing_visit && (
            <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-orange-100 text-orange-700 text-[10px] font-semibold rounded-full">
              <PlayCircle size={10} /> Ongoing
            </span>
          )}
        </div>
        <div className="grid grid-cols-2 gap-2 mb-3">
          <Mini label="Visits today" value={summary?.visits_today ?? '—'} tone="text-blue-700" icon={<BarChart3 size={14} />} />
          <Mini label="Status" value={summary?.ongoing_visit ? 'In progress' : 'Idle'} tone="text-emerald-700" />
        </div>
        <button
          onClick={() => setShowFull(s => !s)}
          className="w-full flex items-center justify-center gap-1 px-3 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-sm font-semibold"
          data-testid="visits-open-full"
        >
          {showFull ? 'Hide details' : 'Open full visits'} <ChevronRight size={14} className={showFull ? 'rotate-90 transition-transform' : 'transition-transform'} />
        </button>
      </div>

      {showFull && <MyVisits />}
    </div>
  );
}

function Mini({ label, value, tone, icon }) {
  return (
    <div className="bg-gray-50 rounded-lg p-2">
      <div className="flex items-center gap-1 text-[10px] text-gray-500 uppercase">
        {icon}{label}
      </div>
      <p className={`text-lg font-bold ${tone || 'text-gray-900'}`}>{value}</p>
    </div>
  );
}
